import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { licenseTrackerEnvironment } from '../license-tracker-environment';

/**
 * Requests a license tracking report from a certain start time, to a certain
 * end time, and sends it to certain emails
 * @param startTime The start time of the request
 * @param endTime The end time of the request
 * @param recipients The recipients of the request
 * @returns An object indicating success
 */
export function postReport(
  this: unknown,
  startTime: Date,
  endTime: Date,
  recipients: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(licenseTrackerEnvironment.resolve(this).reportUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({
          startTime: startTime.toISOString(),
          endTime: endTime.toISOString(),
          recipients,
        }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        receipt: z.string(),
      })
    )
  );
}
